import * as Styled from '../../../../features/filters/components/Filter/Filter.styled';
import type { FilterProps } from '../../../../features/filters/components/Filter/Filter.typed';
import { FiltersV2 } from '../../../../features/filters/FiltersV2';

const Filter = (props: FilterProps) => {
  const {
    item,
    locationConfiguration,
    makeModelConfiguration,
    validPriceConfiguration,
    sectionName,
    onChange,
    filterValue,
  } = props;

  return (
    <Styled.FilterListItem>
      <Styled.FilterWrapper gap={item.type === 'filter' ? 'M16' : 'M24'}>
        <FiltersV2
          filter={{ ...item, onChange, value: filterValue }}
          locationConfiguration={locationConfiguration}
          makeModelConfiguration={makeModelConfiguration}
          validPriceConfiguration={validPriceConfiguration}
          sectionName={sectionName}
        />
      </Styled.FilterWrapper>
    </Styled.FilterListItem>
  );
};

export { Filter };
